import axios from "axios";

// USER START MANAGEMENT
export async function requestGetUserList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/users?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword,
		)}&filter=${filter}&order=${order}`,
	);
}

export async function requestCreateUser(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/users/add`, payload);
}

export async function requestGetUserDetail(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/users/${id}`);
}

export async function requestUpdateUser(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/users/${id}/edit`, payload);
}
// USER MANAGEMENT END

// [GAMIFICATION] BADGE MANAGEMENT START
export async function requestGetBadgeList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/badges?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword,
		)}&filter=${filter}&order=${order}`,
	);
}

export async function requestAwardBadgeToUsers(userIds, badgeId) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/badges/award`, {
		userIds,
		badgeId,
	});
}

export async function requestGetBadgeDetail(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/badges/${id}`);
}

export async function requestCreateBadge(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/badges/add`, payload, {
		headers: { "Content-Type": "multipart/form-data" },
	});
}

export async function requestUpdateBadge(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/badges/${id}/edit`, payload, {
		headers: { "Content-Type": "multipart/form-data" },
	});
}

export async function requestDeleteBadge(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/badges/${id}/delete`);
}
// [GAMIFICATION] BADGE MANAGEMENT END
